import React, { useState, useEffect, memo } from 'react'
import DataTable from 'react-data-table-component';
import DataTableExtensions from 'react-data-table-component-extensions';
import { AiOutlineLike } from 'react-icons/ai';

import './index.css'

//datatable config
const columns = [
  {
    name: 'Id da Fatura',
    selector: 'id',
    sortable: true,
    width: '50px',
  },
  {
    name: 'Data do pagamento',
    selector: 'data',
    sortable: true,
    right: true,
  },
  {
    name: 'Modo de pagamento',
    selector: 'modo',
    sortable: true,
    right: true,
  },
  {
    name: 'Tipo de transação',
    selector: 'transacao',
    sortable: true,
    right: true,
  },
  {
    name: 'Método de pagamento',
    selector: 'metodo',
    sortable: true,
    right: true,
  },
  {
    name: 'Valor da transação',
    selector: 'valor',
    sortable: true,
    center: true
  },
  {
    name: '',
    selector: 'pending',
    cell: (row) => (row.pending &&
      <button className="edit-bank-account">
        Pagar Fatura
        <AiOutlineLike/>
        </button>),
    sortable: true,
    width: '12%',
  },
];

const customStyles = {
  rows: {
    style: {
      '&:hover': {
        backgroundColor: '#03989E',
        color: 'white',
        transition: '.2s'
      },
    }
  },
};

function BillingList({ data }) {
  const [billings, setBillings] = useState([])
  const [billingColumns, setBillingColumns] = useState({})

  useEffect(() => {
    setBillingColumns(columns)
    setBillings(data)
  }, [])

  const tableData = {
    data,
    columns
  };

  return (
    <div className="Billing">
      <DataTableExtensions
        {...tableData}
        filterPlaceholder="Pesquisar faturas"
        print={false}>
        <DataTable
          columns={billingColumns}
          data={billings}
          noDataComponent={
            <span>Nenhum registro de faturas</span>
          }
          pagination={true}
          customStyles={customStyles}
        />
      </DataTableExtensions>
    </div>
  );
}

export default memo(BillingList)